var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12 wrapper"},[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v("No se encontro la pagina ☹️")])])
}]

export { render, staticRenderFns }